import { type V2Bag, type V2Value } from "@/features/applications/api/applications.api";
import { Button } from "@/components/ui/button";
import { APPLICATION_STATUS_LABELS } from "@/components/StatusPill";
import { AWAITING_AGENT_PRICING } from "../pricing";
import { type FieldDef } from "../model";
import { SectionCard } from "../primitives";
import { FieldInput } from "../FieldInput";

export function ReviewStep({
  fields, bag, onChange, status, submitting, saving, onSubmit, onConfigurePricing, showEsign = true,
}: {
  fields: FieldDef[];
  bag: V2Bag;
  onChange: (key: string, value: V2Value) => void;
  status: string;
  submitting: boolean;
  saving: boolean;
  onSubmit: () => void;
  onConfigurePricing?: () => void;
  showEsign?: boolean;
}) {
  return (
    <div className="space-y-5">
      {showEsign && (
        <SectionCard title="eSignature setup">
          <p className="text-sm text-slate-500 -mt-2 mb-4">
            Who needs to sign. The processor will email each signer a secure link to sign — we just pass names + emails.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
            {fields.map((d) => (
              <FieldInput key={d.key} def={d} value={bag[d.key] ?? null} onChange={(v) => onChange(d.key, v)} />
            ))}
          </div>
        </SectionCard>
      )}

      <SectionCard title="Review & submit">
        {status === "Draft" ? (
          <Button type="button" size="lg" onClick={onSubmit} disabled={saving || submitting}>
            {submitting ? "Submitting…" : "Submit application"}
          </Button>
        ) : status === AWAITING_AGENT_PRICING ? (
          <div className="flex flex-wrap items-center gap-3 text-sm text-slate-600">
            <span>Configure pricing, then submit it to back office.</span>
            {onConfigurePricing && (
              <Button type="button" size="sm" onClick={onConfigurePricing}>Configure pricing</Button>
            )}
          </div>
        ) : (
          <div className="text-sm text-slate-600">
            Status is <strong>{APPLICATION_STATUS_LABELS[status] ?? status}</strong> — no further action needed here.
          </div>
        )}
      </SectionCard>
    </div>
  );
}
